import { OrdreFabricationView } from "@features/production/components/OrdreFabricationView";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Eye } from "lucide-react";

export const Route = createFileRoute("/_app/production/ordres-fabrication/$id/")({
  loader: requirePermission(PERMISSIONS.PRODUCTION.OF.VIEW),
  staticData: {
    title: "Détail OF",
    icon: Eye,
    permission: PERMISSIONS.PRODUCTION.OF.VIEW,
    section: "App",
    showInBreadcrumb: true,
  },
  component: OrdreFabricationView,
});
